import styled from 'foundations-theming/utils';

type ResizeableThumbnailOutlineProps = {
  height?: number | string | null;
  width?: number | string | null;
  selected?: boolean | null;
  invertHorizontal?: boolean | null;
  invertVertical?: boolean | null;
};

// Invert Horizontal and Vetical are optional props that can be passed in and
// are based on whether the drag is being inverted in theose directions
export default styled.div<ResizeableThumbnailOutlineProps>`
  border: 3px solid ${({ theme }) => theme.color['fill-accent-blue-hover']};
  cursor: pointer;
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  opacity: ${({ selected }) => (selected ? 1 : 0)};
  position: absolute;
  left: ${({ invertHorizontal }) => (invertHorizontal ? null : '0px')};
  right: ${({ invertHorizontal }) => (invertHorizontal ? '0px' : null)};
  top: ${({ invertVertical }) => (invertVertical ? null : '0px')};
  bottom: ${({ invertVertical }) => (invertVertical ? '0px' : null)};
`;
